/** 中文 */
export default {
    "年龄": "年龄",
    submit: "提交",
    example: {
        name: "张三"
    },
    "欢迎使用交换机云平台": "欢迎使用交换机云平台",
    "请输入手机号或邮箱": "请输入手机号或邮箱",
    "请输入密码(6~12位字母+数字)": "请输入密码(6~12位字母+数字)",
    "登录": "登录",
    "登录中": "登录中",
    "自动登录": "自动登录",
    "忘记密码": "忘记密码",
    "请输入手机号": "请输入手机号",
    "请输入验证码": "请输入验证码",
    "请输入邮箱": "请输入邮箱",
    "没有账号，": "没有账号，",
    "去注册": "去注册",
    "密码登录": "密码登录",
    "手机号验证": "手机号验证",
    "邮箱验证": "邮箱验证",
    "请正确输入手机号或邮箱": "请正确输入手机号或邮箱",
    "请输入正确的密码(6~12位字母+数字)": "请输入正确的密码(6~12位字母+数字)",
    "登录成功！": "登录成功！",
    "登录失败": "登录失败",
    "手机号格式不正确": "手机号格式不正确",
    "邮箱格式不正确": "邮箱格式不正确",

    "返回登录": "返回登录",
    "确认": "确认",
    "请输入密码": "请输入密码",
    "确认中": "确认中",
    "重置密码成功": "重置密码成功",
    "忘记密码失败": "忘记密码失败",
    "注册账号": "注册账号",
    "请选择": "请选择",
    "请输入邀请码(必填)": "请输入邀请码(必填)",
    "注册": "注册",
    "注册中": "注册中",
    "已阅读并同意": "已阅读并同意",
    "《用户注册协议》": "《用户注册协议》",
    "与": "与",
    "《隐私政策》": "《隐私政策》",
    "用户协议": "用户协议",
    "隐私协议": "隐私协议",
    "普通用户": "普通用户",
    "工程商": "工程商",
    "代理商": "代理商",
    "请输入邀请码（必填）": "请输入邀请码（必填）",
    "请查看并勾选用户协议": "请查看并勾选用户协议",
    "注册成功！": "注册成功！",
    "注册失败": "注册失败",
    "获取验证码": "获取验证码",
    "手机号输入错误请重新输入": "手机号输入错误请重新输入",
    "邮箱输入错误请重新输入": "邮箱输入错误请重新输入",
    "重新获取": "重新获取",
    "验证码发送成功": "验证码发送成功",
    "失败": "失败",
    "概览": "概览",
    "项目": "项目",
    "设备": "设备",
    "维护": "维护",
    "个人设置": "个人设置",
    "退出登录": "退出登录",
    "确定退出系统吗？": "确定退出系统吗？",
    "提示": "提示",
    "取消": "取消",
    "基本设置": "基本设置",
    "安全设置": "安全设置",

    "姓名/昵称": "姓名/昵称",
    "请输入": "请输入",
    "手机": "手机",
    "电子邮件": "电子邮件",
    "性别": "性别",
    "保密": "保密",
    "男": "男",
    "女": "女",
    "保存": "保存",
    "请上传头像": "请上传头像",
    "请输入姓名/昵称": "请输入姓名/昵称",

    "无": "无",
    "账号密码": "账号密码",
    "用于保护帐号信息和登录安全": "用于保护帐号信息和登录安全",
    "修改": "修改",
    "绑定手机号": "绑定手机号",
    "绑定邮箱": "绑定邮箱",

    "修改密码": "修改密码",
    "原密码验证": "原密码验证",

    "返回": "返回",
    "原密码": "原密码",
    "请输入原密码": "请输入原密码",
    "新密码": "新密码",
    "请输入新密码": "请输入新密码",
    "确认密码": "确认密码",
    "请再次输入新密码": "请再次输入新密码",
    "请输入旧密码": "请输入旧密码",
    "请输入旧密码（6~12位字母+数字）": "请输入旧密码（6~12位字母+数字）",
    "请输入新密码（6~12位字母+数字）": "请输入新密码（6~12位字母+数字）",
    "请再次输入新密码（6~12位字母+数字）": "请再次输入新密码（6~12位字母+数字）",
    "两次输入密码不一致": "两次输入密码不一致",
    "成功": "成功",

    "手机号": "手机号",
    "验证码": "验证码",
    "密码": "密码",
    "请输入正确的验证码": "请输入正确的验证码",
    "邮箱": "邮箱",

    "换绑手机号": "换绑手机号",
    "设置": "设置",
    "绑定": "绑定",
    "原手机号": "原手机号",
    "下一步": "下一步",
    "新手机号": "新手机号",
    "请输入新手机号": "请输入新手机号",
    "更新成功": "更新成功",
    "换绑邮箱": "换绑邮箱",
    "请输入正确的邮箱": "请输入正确的邮箱",
    "绑定成功": "绑定成功",
    "请输入密码（6~12位字母+数字）": "请输入密码（6~12位字母+数字）",
    "请输入正确的手机号": "请输入正确的手机号",
    "原邮箱": "原邮箱",
    "请输入原邮箱": "请输入原邮箱",
    "请输入新邮箱": "请输入新邮箱",

    "订阅消息类型": "订阅消息类型",
    "配置异常": "配置异常",
    "设备异常": "设备异常",
    "网络安全": "网络安全",
    "接入异常": "接入异常",
    "设备上线/掉线": "设备上线/掉线",
    "其他异常": "其他异常",
    "系统升级": "系统升级",
    "配置操作": "配置操作",
    "射频调优": "射频调优",
    "端口异常": "端口异常",
    "终端异常": "终端异常",
    "订阅项目": "订阅项目",
    "请选择要订阅的项目": "请选择要订阅的项目",
    "告警接收人邮箱": "告警接收人邮箱",

    "告警": "告警",
    "告警记录": "告警记录",
    "告警设置": "告警设置",

    "全部": "全部",
    "未读": "未读",
    "已读": "已读",
    "项目名称：": "项目名称：",
    "设备类型：": "设备类型：",
    "设备SN：": "设备SN：",
    "搜索": "搜索",
    "重置": "重置",
    "一键已读": "一键已读",
    "项目名称": "项目名称",
    "设备类型": "设备类型",
    "设备名称": "设备名称",
    "设备SN": "设备SN",
    "管理IP": "管理IP",
    "告警类型": "告警类型",
    "告警级别": "告警级别",
    "告警内容": "告警内容",
    "告警时间": "告警时间",
    "告警读取时间": "告警读取时间",

    "项目概览": "项目概览",
    "设备概览": "设备概览",
    "告警概览": "告警概览",
    "项目搜索": "项目搜索",
    "创建项目": "创建项目",
    "我的项目": "我的项目",
    "查看更多": "查看更多",
    "交换机": "交换机",
    "智能箱": "智能箱",
    "操作": "操作",
    "导出报告": "导出报告",
    "导出设备": "导出设备",
    "进入项目": "进入项目",
    "我的接收": "我的接收",

    "请输入项目名称": "请输入项目名称",
    "请输入设备类型": "请输入设备类型",
    "请输入设备SN": "请输入设备SN",
    "请输入MAC地址": "请输入MAC地址",
    "软件版本": "软件版本",
    "更新时间": "更新时间",
    "状态": "状态",

    "网络拓扑": "网络拓扑",
    "地图定位": "地图定位",
    "设备详情": "设备详情",
    "端口详情": "端口详情",
    "标注端口状态": "标注端口状态",
    "设备监控": "设备监控",
    "设备配置": "设备配置",

    "刷新": "刷新",
    "整网重启": "整网重启",
    "整网升级": "整网升级",
    "配置VLAN": "配置VLAN",
    "端口": "端口",

    "xxx下发重启失败": "{name}下发重启失败",
    "xxx已是最新版本": "{name}已是最新版本",
    "端口X为上行接口，如修改上行接口的vlan模式配置，会存在设备和服务端网络中断的风险，请谨慎操作！！！": "端口{name}为上行接口，如修改上行接口的vlan模式配置，会存在设备和服务端网络中断的风险，请谨慎操作！！！",

    "添加": "添加",
    "批量开启": "批量开启",
    "批量关闭": "批量关闭",
    "删除": "删除",
    "无数据": "无数据",
    "端口列表": "端口列表",
    "全选端口": "全选端口",
    "取消全选": "取消全选",
    "端口选择：": "端口选择：",
    "是否已设置": "是否已设置",
    "取消隔离": "取消隔离",
    "聚合号": "聚合号",
    "请输入端口聚合号": "请输入端口聚合号",
    "编辑": "编辑",
    "广播": "广播",
    "未知名组播": "未知名组播",
    "未知名单播": "未知名单播",
    "端口：": "端口：",
    "输入限速：": "输入限速：",
    "输出限速：": "输出限速：",
    "是": "是",
    "否": "否",
    "输入限速": "输入限速",
    "输出限速": "输出限速",
    "PoE全局信息": "PoE全局信息",
    "更新时间：": "更新时间：",
    "总功率": "总功率",
    "实时功率": "实时功率",
    "PoE端口列表": "PoE端口列表",
    "链接状态": "链接状态",
    "端口电源": "端口电源",
    "电压": "电压",
    "电压（V）": "电压（V）",
    "电流": "电流",
    "电流（mA）": "电流（mA）",
    "功率": "功率",
    "优先级": "优先级",
    "收发器状态": "收发器状态",
    "温度（℃）": "温度（℃）",
    "接收功率（dBm）": "接收功率（dBm）",
    "发送功率（dBm）": "发送功率（dBm）",
    "检测结果": "检测结果",
    "检测时间": "检测时间",
    "开始检测": "开始检测",
    "上行速率（Mbps）": "上行速率（Mbps）",
    "下行速率（Mbps）": "下行速率（Mbps）",
    "VLAN配置": "VLAN配置",
    "选择设备": "选择设备",
    "请选择选择设备": "请选择选择设备",
    "请输入2～4094间的数值": "请输入2～4094间的数值",
    "名称": "名称",
    "请输入1～12个字符": "请输入1～12个字符",
    "模式": "模式",
    "请选择VLAN模式": "请选择VLAN模式",
    "说明：端口图标中的数字为PVID，此类端口为上联口": "说明：端口图标中的数字为PVID，此类端口为上联口",
    "相同汇聚组LAG的端口，只能同时为Untagged或Tagged": "相同汇聚组LAG的端口，只能同时为Untagged或Tagged",
    "上联口速率(Mbps)": "上联口速率(Mbps)",
    "上行速率": "上行速率",
    "下行速率": "下行速率",
    "端口速度": "端口速度",
    "设备状态": "设备状态",
    "添加设备": "添加设备",
    "EWEB": "EWEB",
    "重启": "重启",
    "升级": "升级",
    "时间同步": "时间同步",
    "解绑": "解绑",
    "分组": "分组",
    "设备型号": "设备型号",
    "所属项目": "所属项目",
    "请选择项目": "请选择项目",
    "所属分组": "所属分组",
    "请选择分组": "请选择分组",
    "添加分组": "添加分组",
    "设备SN码": "设备SN码",
    "请选择设备SN码": "请选择设备SN码",
    "vlan名称": "vlan名称",
    "角色": "角色",
    "删除项目": "删除项目",
    "批量配置": "批量配置",
    "VLAN名称": "VLAN名称",
    "TAGGED端口": "TAGGED端口",
    "UNTAGGED端口": "UNTAGGED端口",
    "项目分组": "项目分组",
    "序号": "序号",
    "项目名": "项目名",
    "分组名": "分组名",
    "使用": "使用",
    "操作日志": "操作日志",
    "用户名": "用户名",
    "操作类型": "操作类型",
    "操作对象": "操作对象",
    "操作结果": "操作结果",
    "时间": "时间",
    "开始时间": "开始时间",
    "结束时间": "结束时间",
    "备注": "备注",
    "成员管理": "成员管理",
    "共享项目": "共享项目",
    "删除成员": "删除成员",
    "权限": "权限",
    "定时升级": "定时升级",
    "是否开启": "是否开启",
    "设备将在设定时间自动升级": "设备将在设定时间自动升级",
    "添加时间": "添加时间",
    "升级时间": "升级时间",
    "请选择时间": "请选择时间",
    "设备将在设定时间以后自动升级": "设备将在设定时间以后自动升级",
    "立即升级": "立即升级",
    "请选择要升级的设备类型": "请选择要升级的设备类型",
    "开启": "开启",
    "关闭": "关闭",
    "定时重启": "定时重启",
    "重启时间": "重启时间",
    "后": "后",
    "设备将在设定时间以后自动重启": "设备将在设定时间以后自动重启",
    "立即重启": "立即重启",
    "请选择要重启的设备类型": "请选择要重启的设备类型",
    "请输入分组名": "请输入分组名",
    "账号": "账号",
    "地图选点": "地图选点",
    "无项目": "无项目",
    "我的分享": "我的分享",
    "项目管理": "项目管理",
    "托管": "托管",
    "共享": "共享",
    "管理员": "管理员",
    "AP": "AP",
    "AC": "AC",
    "移交项目": "移交项目",
    "创建企业": "创建企业",
    "删除企业": "删除企业",
    "企业名称": "企业名称",
    "项目数量": "项目数量",
    "无设备信息": "无设备信息",
    "请选择设备类型": "请选择设备类型",
    "请选择设备SN": "请选择设备SN",
    "未搜索到项目": "未搜索到项目",
    "你好": "你好",

    "设备告警记录": "设备告警记录",
    "项目信息": "项目信息",
    "项目MAP": "项目MAP",
    "角色名称": "角色名称",
    "角色权限": "角色权限",
    "成员信息": "成员信息",
    "编辑报告信息": "编辑报告信息",
    "报告名称": "报告名称",
    "项目负责人": "项目负责人",
    "联系电话": "联系电话",
    "交付日期": "交付日期",
    "年/月/日": "年/月/日",
    "确认导出": "确认导出",
    "企业信息": "企业信息",
    "用户角色": "用户角色",
    "搜索关键词": "搜索关键词",
    "确定": "确定",
    "安卓端": "安卓端",
    "IOS端": "IOS端",
    "已选中X个端口": "已选中X个端口",
    "请选择设备型号": "请选择设备型号",
    "出口速率": "出口速率",
    "入口速率": "入口速率",
    "留空或0表示不限速": "留空或0表示不限速",
    "端口速率双工": "端口速率双工",
    "角色信息": "角色信息",
    "请输入用户手机号/邮箱": "请输入用户手机号/邮箱",
    "请选择角色": "请选择角色",
    "当前设备软件均为最新版本，无需升级": "当前设备软件均为最新版本，无需升级",
    "知道了": "知道了",
    "端口限速": "端口限速",
    "端口隔离": "端口隔离",
    "风暴控制": "风暴控制",
    "静态LACP": "静态LACP",
    "线缆检测": "线缆检测",
    "DDM信息": "DDM信息",
    "PoE信息": "PoE信息",
    "上联口": "上联口",
    "端口开关": "端口开关",
    "端口速率/双工：自协商": "端口速率/双工：自协商",
    "入口速率(Mbps)：不限速": "入口速率(Mbps)：不限速",
    "出口速率(Mbps)：不限速": "出口速率(Mbps)：不限速",
    "近24小时": "近24小时",
    "项目体验": "项目体验",
    "APP下载": "APP下载",
    "快速添加": "快速添加",
    "快速解绑": "快速解绑",
    "快速查找": "快速查找",
    "企业管理": "企业管理",
    "搜索结果": "搜索结果",
    "系统消息": "系统消息",
    "详情": "详情",
    "端口信息": "端口信息",
    "未连接": "未连接",
    "电口": "电口",
    "光口": "光口",
    "聚合口": "聚合口",
    "POE供电": "POE供电",
    "供电异常": "供电异常",
    "阻塞口": "阻塞口",
    "无线AC": "无线AC",
    "无线AP": "无线AP",
    "网桥": "网桥",
    "出口路由器": "出口路由器",
    "电脑": "电脑",
    "打印机": "打印机",
    "摄像机": "摄像机",
    "服务器": "服务器",
    "光纤收发器": "光纤收发器",
    "在线": "在线",
    "离线": "离线",

    "保存成功": "保存成功",
    "是否删除该vlan？": "是否删除该vlan？",
    "是否要删除选中的vlan？": "是否要删除选中的vlan？",
    "请选择要删除的vlan": "请选择要删除的vlan",
    "删除成功": "删除成功",
    "是否删除该端口限速？": "是否删除该端口限速？",
    "请输入输入限速": "请输入输入限速",
    "请输入输出限速": "请输入输出限速",

    "项目添加成功": "项目添加成功",
    "项目编辑成功": "项目编辑成功",
    "端口速率(Mbps)": "端口速率(Mbps)",
    "上行速度": "上行速度",
    "端口速率/双工：": "端口速率/双工：",
    "入口速率(Mbps)：": "入口速率(Mbps)：",
    "不限速": "不限速",
    "出口速率(Mbps)：": "出口速率(Mbps)：",
    "备注：": "备注：",
    "端口速率双工：": "端口速率双工：",
    "已取消操作": "已取消操作",
    "上行": "上行",
    "下行": "下行",
    "端口备注": "端口备注",
    "PoE开关": "PoE开关",
    "PoE看门狗": "PoE看门狗",
    "下发成功": "下发成功",
    "说明：端口图标中的数字为PVID，": "说明：端口图标中的数字为PVID，",
    "此类端口为上联口": "此类端口为上联口",
    "端口模式配置": "端口模式配置",
    "注：端口若为上行接口，修改vlan模式配置，会存在设备和服务端网络中断的风险": "注：端口若为上行接口，修改vlan模式配置，会存在设备和服务端网络中断的风险",
    "vlan模式": "vlan模式",

    "监控": "监控",
    "配置": "配置",
    "端口统计": "端口统计",
    "历史报警/消息": "历史报警/消息",
    "标注端口连接设备": "标注端口连接设备",
    "端口监测到回环后会自动被阻塞，防止环路": "端口监测到回环后会自动被阻塞，防止环路",
    "环回保护": "环回保护",
    "展开端口展示": "展开端口展示",
    "收起端口展示": "收起端口展示",
    "近1小时": "近1小时",
    "近12小时": "近12小时",
    "近7天": "近7天",
    "端口状态": "端口状态",
    "连接设备类型标注": "连接设备类型标注",
    "项目类型": "项目类型",
    "更多": "更多",
    "请选择设备": "请选择设备",
    "请输入VLAN ID": "请输入VLAN ID",
    "请输入VLAN ID（2～4094间的数值）": "请输入VLAN ID（2～4094间的数值）",
    "请输入VLAN名称": "请输入VLAN名称",
    "是否解绑该设备？": "是否解绑该设备？",
    "创建项目功能": "创建项目功能",
    "添加角色功能": "添加角色功能",
    "导出报告功能": "导出报告功能",
    "导出设备功能": "导出设备功能",
    "进入项目功能": "进入项目功能",
    "编辑企业功能": "编辑企业功能",
    "请选择要重启的设备": "请选择要重启的设备",
    "请选择要升级的设备": "请选择要升级的设备",
    "请选择要时间同步的设备": "请选择要时间同步的设备",
    "请选择要解绑的设备": "请选择要解绑的设备",
    "内存": "内存",
    "端口选择": "端口选择",
    "一般": "一般",
    "中等": "中等",
    "严重": "严重",
    "请检查表单信息是否正确": "请检查表单信息是否正确",
    "报告导出成功": "报告导出成功",
    "请选择企业": "请选择企业",
    "请输入项目MAP": "请输入项目MAP",
    "请选择项目坐标": "请选择项目坐标",
    "请选择要删除的项目": "请选择要删除的项目",
    "请先选择要删除的分组": "请先选择要删除的分组",
    "是否要删除该分组": "是否要删除该分组",
    "请选择要删除的成员": "请选择要删除的成员",
    "是否要删除选中的成员？": "是否要删除选中的成员？",
    "是否要删除该的成员？": "是否要删除该的成员？",
    "请输入企业名称": "请输入企业名称",
    "请选择要删除的企业": "请选择要删除的企业",
    "是否要删除选中的企业？": "是否要删除选中的企业？",
    "企业删除成功": "企业删除成功",
    "企业删除失败": "企业删除失败",
    "改变成功": "改变成功",
    "是否要删除该定时？": "是否要删除该定时？",
    "配置成功": "配置成功",
    "不可对同一端口同时进行Untagged和Tagged操作": "不可对同一端口同时进行Untagged和Tagged操作",
    "access模式不可编辑Tagged": "access模式不可编辑Tagged",
    "确认重启设备？": "确认重启设备？",
    "是否重启选中的设备？": "是否重启选中的设备？",
    "重启成功": "重启成功",
    "是否升级选中的设备？": "是否升级选中的设备？",
    "升级成功": "升级成功",
    "是否时间同步选中的设备？": "是否时间同步选中的设备？",
    "时间同步成功": "时间同步成功",
    "是否解绑选中的设备？": "是否解绑选中的设备？",
    "解绑成功": "解绑成功",
    "是否取消该端口隔离？": "是否取消该端口隔离？",
    "请选择要隔离的端口": "请选择要隔离的端口",
    "是否删除该端口风暴控制？": "是否删除该端口风暴控制？",
    "请选择要风暴控制的端口": "请选择要风暴控制的端口",
    "请输入广播": "请输入广播",
    "请输入未知名组播": "请输入未知名组播",
    "请输入未知名单播": "请输入未知名单播",
    "是否删除该静态LACP？": "是否删除该静态LACP？",
    "请选择要静态LACP的端口": "请选择要静态LACP的端口",
    "确认升级设备？": "确认升级设备？",
    "下发升级成功": "下发升级成功",
    "xxx设备已是最新版本": "{name}设备已是最新版本",
    "是否要删除选中的项目？": "是否要删除选中的项目？",
    "项目删除成功": "项目删除成功",
    "项目删除失败": "项目删除失败",
    "无项目id": "无项目id",
    "设备信息": "设备信息",
    "是否要删除选中的分组": "是否要删除选中的分组",
    "请输入设备SN码": "请输入设备SN码",
    "成员删除失败": "成员删除失败",
    "编辑成功": "编辑成功",
    "企业添加成功": "企业添加成功",
    "请输入备注": "请输入备注",
    "输入限速(Mbps)：": "输入限速(Mbps)：",
    "输出限速(Mbps)：": "输出限速(Mbps)：",
    "该端口不支持PoE": "该端口不支持PoE",
    "编辑名称": "编辑名称",
    "批量编辑": "批量编辑",
    "请选择要取消隔离的端口": "请选择要取消隔离的端口",
    "是否取消选中的端口隔离？": "是否取消选中的端口隔离？",
    "取消成功": "取消成功",
    "该端口已设置隔离": "该端口已设置隔离",
    "聚合组": "聚合组",
    "端口模式不匹配，不可编辑": "端口模式不匹配，不可编辑",
}
